import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'college boxes storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college boxes storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Fast <span>and Secure</span><span>College Boxes Storage</span>',
  description:
    'Reliable and efficient College Boxes Storage solutions designed for students. Enjoy free insurance, flexible storage options, and hassle-free services tailored to your needs.',
  image: {
    url: '/images/v2/pages/landing-pages/college-boxes-storage/hero-image.jpg',
    alt: 'Fast and Secure College Boxes Storage'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for College Box Storage' }
}

export const ourProcessSectionContent = {
  title: 'How We Offer Fast College Storage Solutions',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get Started' },

  image: {
    url: '/images/v2/pages/landing-pages/college-boxes-storage/how-we-offer-fast-college-storage-solutions.png',
    alt: 'How We Offer Fast College Storage Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Pickup and Delivery',
      description: 'We pick up and deliver your boxes, ensuring maximum convenience and saving you time.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/easy-pickup-and-delivery.png',
        alt: 'Easy Pickup and Delivery'
      }
    },
    {
      id: 2,
      title: 'Secure Facilities',
      description:
        'Our climate-controlled and monitored storage ensures your items are safe, no matter how long you store them.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/secure-facilities.png',
        alt: 'Secure Facilities'
      }
    },
    {
      id: 3,
      title: 'Affordable Plans',
      description: 'Flexible, student-friendly pricing options tailored to fit any budget.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/affordable-plans.png',
        alt: 'Affordable Plans'
      }
    }
  ]
}

export const affordableCollegeSectionContent = {
  id: 1,
  title: 'Affordable College Boxes Storage Services',
  description:
    'Our College Boxes Storage services are designed to offer students a cost-effective and reliable solution for storing their belongings. With flexible plans, free insurance, and no hidden fees, you can trust us to keep your items safe and accessible whenever you need them.',
  image: {
    src: '/images/v2/pages/landing-pages/college-boxes-storage/affordable-college-boxes-storage-services.jpg',
    alt: 'Affordable College Boxes Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using College Boxes Storage Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description: 'Effortless pickup and delivery options fit seamlessly into your busy college schedule.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Cost-Effective',
      description: 'Enjoy competitive pricing and free insurance up to $250 to save money while securing your items.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/cost-effective.png',
        alt: 'Cost-Effective'
      }
    },
    {
      id: 3,
      title: 'Peace of Mind',
      description: 'Rest assured knowing your belongings are stored in secure, climate-controlled facilities.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/peace-of-mind.png',
        alt: 'Peace of Mind'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for College Boxes Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students Living Far from Campus',
          description:
            'Ideal for those who need a secure place to store their belongings during vacations or study abroad.'
        },
        {
          id: 2,
          title: 'Seasonal Storage Needs',
          description: 'Perfect for storing items like winter clothing, sports equipment, or extra dorm supplies.'
        },
        {
          id: 3,
          title: 'College Students on the Move',
          description:
            'Whether you’re switching dorms or transitioning between academic years, we provide hassle-free storage solutions.'
        },
        {
          id: 4,
          title: 'Anyone Seeking Flexible Storage Options',
          description: 'With customized plans and reliable services, we cater to all your college storage needs.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/who-should-choose-us-for-college-boxes-storage-services.jpg',
        alt: 'Who Should Choose Us for College Boxes Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Secure and efficient storage for office supplies, documents, or equipment for small businesses and entrepreneurs.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/business-storage-solution.png',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'A seamless option for relocations, offering safe temporary storage and convenient moving assistance.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Affordable shipping solutions for students traveling home or abroad, ensuring your items reach their destination safely.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'A reliable option for homeowners or renters needing to store belongings during transitions, renovations, or downsizing.',
      image: {
        src: '/images/v2/pages/landing-pages/college-boxes-storage/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for College Boxes Storage Services',

  image: {
    url: '/images/v2/pages/landing-pages/college-boxes-storage/why-choose-us-for-college-boxes-storage-services.jpg',
    alt: 'Why Choose Us for College Boxes Storage Services'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Rates',
      description: 'We provide competitive pricing designed for student budgets.'
    },
    {
      id: 2,
      title: 'Free Insurance',
      description: 'Coverage up to $250 ensures your items are secure without extra cost.'
    },
    {
      id: 3,
      title: 'Flexible Options',
      description: 'From 1 small box to 100 large boxes, we have the capacity to meet any storage requirement.'
    },
    {
      id: 4,
      title: 'Secure Storage',
      description: 'Our climate-controlled, monitored facilities protect your items from damage or theft.'
    },
    {
      id: 5,
      title: 'Fast Service',
      description: 'Quick pickups and deliveries make the process hassle-free and efficient.'
    },
    {
      id: 6,
      title: 'Reliable Support',
      description: 'Our team is always ready to assist and ensure a smooth storage experience.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'College Boxes Storage Services for Students Available',
  description:
    'College boxes storage services available. Fast, secure solutions for storing and shipping your belongings during the school year.',
  image: {
    src: '/images/v2/pages/landing-pages/college-boxes-storage/college-boxes-storage-services-for-students-available.png',
    alt: 'College Boxes Storage Services for Students Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Secure Your Space' }
}

export const ourPartnersSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'At ShipAndStorage, we proudly collaborate with top global carriers, including FedEx, DHL, and UPS, to provide outstanding shipping and storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Established in 1971 by Frederick W. Smith, FedEx began its journey with just 186 packages and has grown into a global shipping leader. Today, the company operates a fleet of 696 aircraft and 215,000 vehicles, handling approximately 16 million shipments daily across over 220 countries and territories. With more than 550,000 dedicated employees and 5,000 locations worldwide, FedEx is committed to ensuring reliable and timely deliveries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx"
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a key division of Deutsche Post DHL Group, is well-known for its international courier, parcel, and express mail services. As a leader in logistics, DHL handles over 1.8 billion parcels each year. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in more than 220 countries, playing a crucial role in the global supply chain.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, <a href='https://www.dhl.com/us-en/home.html' target='_blank'>visit DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Founded in 1907 in Seattle as the American Messenger Company by teenagers Claude Ryan and Jim Casey, UPS rebranded to United Parcel Service (UPS) in 1919. Today, UPS ranks among the largest shipping companies globally, delivering around 25 million packages each day. With a workforce exceeding 500,000 employees worldwide, UPS serves over 220 countries and territories, providing unparalleled global reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy of the information provided. For further details, <a href='https://www.ups.com/us/en/home.page' target='_blank'>visit UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
